import React from 'react';
import type { ExtendWithCommonProps } from '../../types';
import { Spinner } from '../spinner/spinner';
import { type ButtonProps } from './button';
import { useButton } from './button-context';

export type ButtonSpinnerProps = ExtendWithCommonProps<{
  /** If true, component is loading and displayed. */
  loading?: ButtonProps['loading'];
}>;

export const ButtonSpinner = React.forwardRef<
  React.ElementRef<typeof Spinner>,
  ButtonSpinnerProps
>((props, ref) => {
  const context = useButton();
  const { loading } = { ...context, ...props };
  return <Spinner size={'md'} loading={loading} ref={ref} />;
});

ButtonSpinner.displayName = 'Button.Spinner';
